import axios from "axios";
import { get } from "lodash";
import { queryClient } from "../queries/queryClient";

const TIMEOUT = 30000; // 30 seconds

const apiBase = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/api`,
  timeout: process.env.NODE_ENV === "development" ? TIMEOUT * 10 : 30000,
  withCredentials: true, // Enable sending/receiving cookies
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

apiBase.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = get(error, "response.status");
    const requestUrl = get(error, "config.url", "");

    if (status === 503) {
      window.localStorage.clear();
      window.location.href = "/maintanence";
    }

    // Expired/invalid session: drop the token, clear the query cache, and send
    // the user to login. Guards keep this from firing spuriously: only act when
    // a session token is actually present (a stray 401 on a logged-out client
    // shouldn't redirect), skip the authenticate endpoint (a wrong password
    // surfaces its own error), and skip when already on /login.
    if (
      status === 401 &&
      !requestUrl.includes("users/authenticate") &&
      window.localStorage.getItem("authToken") &&
      window.location.pathname !== "/login"
    ) {
      window.localStorage.removeItem("authToken");
      queryClient.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export { apiBase };
